import {ButtonHTMLAttributes, FC, ReactElement} from 'react'
import {BaseButtonType, Button} from 'shared/ui/buttons'
import styles from './styles.module.scss'

type BaseProps = {
  icon: ReactElement
  alignIcon?: 'left | right',
  size?: 'small | medium | large'
  alt: string,
}

type IconButtonProps = BaseProps & ButtonHTMLAttributes<HTMLButtonElement> & BaseButtonType

export const IconButton: FC<IconButtonProps> = ({
  alignIcon = 'left',
  alt,
  size = 'medium',
  children,
  className,
  icon,
  ...rest
}) => {


  return (
    <Button className={`${styles.btnWithIcon} ${className}`} {...rest} >
      <div className={`${styles[alignIcon ? alignIcon : 'left']} ${styles.icon} ${styles[size]}`}>
        {icon}
      </div>
      {children}
    </Button>
  )
}